import React, { useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { compose } from "@reduxjs/toolkit";
import * as yup from "yup";

import COMMON from "common";
import ERRORS from "common/errors";
import api from "services/api";
import pathnames from "routes/pathnames";
import withProfile from "contexts/with-profile";
import serveRequestErrors from "common/serve-request-errors";
import AppAlert from "components/app-alert";
import AppInput from "components/app-input";
import AppButton from "components/app-button";
import logo from "assets/images/logo.webp";
import AppOtpModal from "components/app-otp-modal";

const PageVerifyEmail = (props) => {
    const otpModalRef = useRef();
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {            
            email: "",
        },
        validationSchema: yup.object({            
            email: yup.string().matches(COMMON.REGEX.EMAIL, ERRORS.EMAIL).required(ERRORS.REQUIRED),
        }),
        onSubmit: (values) => {
            onHandleSendOtp(values);
        },
    });

    const onHandleSendOtp = async (values) => {
        try{
            await api.post.general.sendResetPasswordOtp({ email: values.email });

            formik.setSubmitting(false);
            onHandleOtpModal();

        } catch (error) {
            serveRequestErrors(error, (message) => {
                formik.setFieldError("email", message);
            });
        } finally {
            formik.setSubmitting(false);
        }
    };

    const onHandleNavigate = useCallback(async (otpCode) => {
        let values = { ...formik.values, otpCode };

        try {
            
            navigate(pathnames.forgotPassword.resetPassword, {
                state: {
                    otpCode: values.otpCode,
                    email: values.email,
                }
            });

        } catch (error) {
            serveRequestErrors(error, (message) => {                
                formik.setFieldError("email", message);
            });
        } finally {
            formik.setSubmitting(false);
        }
    }, [formik, navigate]);

    const onHandleBack = useCallback(() => {
        navigate(pathnames.login);
    }, [navigate]);

    //prettier-ignore    
    const onHandleOtpModal = useCallback(() => {
        otpModalRef.current.onHandleShow();
    }, []);

    return (
        <div className="page-vefiry-email">
            <div className="vefiry-email">
                <AppAlert />

                <main className="main">
                    <div className="main__content main__content--background">
                        <Link to={pathnames.login} className="main__logo">
                            <img src={logo} alt="logo" />
                        </Link>
                    </div>

                    <div className="main__content main__content--form">
                        <form className="main__form" onSubmit={formik.handleSubmit}>
                            <h1 className="main__title">Email Verification</h1>
                            <p className="main__description">Please fill in your email address.</p>

                            {/* prettier-ignore */}
                            <AppInput required type="text" name="email" label="Email Address" placeholder="Enter email address" value={formik.values.email} error={formik.errors.email} touched={formik.touched.email} onChange={formik.handleChange} />                           

                            <div className="main__button-container main__button-container--row">
                                <AppButton outline type="button" label="Back" onClick={onHandleBack} />
                                <AppButton type="submit" label="Next" disabled={formik.isSubmitting} />
                            </div>
                        </form>

                        <p className="main__copyright">© {new Date().getFullYear()} Altecflex.my. All Rights Reserved.</p>
                    </div>
                </main>
            </div>

            <AppOtpModal email={formik.values.email} ref={otpModalRef} isResetPassword={true} onSubmit={onHandleNavigate} />
        </div>
    );
};

export default compose(withProfile)(PageVerifyEmail);
